module.exports = __webpack_public_path__ + "img/logo_expar.e99d7d9b.png";